import axios from 'axios';
import { apiBaseUrl } from 'App';
import { LoginResponse } from './loadSessionData';
import { convertLocalDateTimeToUTC } from 'internationalization/timezoneConversions';
import { getNavigatorLanguageOrFallback } from 'internationalization/i18n';

// Fetches the session payload of the environment this tab is pinned to, the
// request interceptor adds the environment header so the backend answers
// for the pinned environment instead of the stored one
export const fetchSessionData = async (): Promise<LoginResponse> => {
    // Get the current utc datetime for the subscription checks of the payload
    const navigator_locale = getNavigatorLanguageOrFallback(navigator.language, 'locale');
    const navigator_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    const utc_datetime = convertLocalDateTimeToUTC(new Date(), navigator_locale, navigator_timezone);

    // Fetch the session payload
    const response = await axios.get<LoginResponse>(`${apiBaseUrl}/get_session_data/`, {
        params: { utc_datetime },
        withCredentials: true,
    });

    return response.data;
};
